import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Outlet, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
// import LoginForm from './components/auth/LoginForm';
// import PinLoginForm from './components/auth/PinLoginForm';
import PinLoginFormEnhanced from './components/auth/PinLoginFormEnhanced';
import BentoOrderNotificationEnhanced from './components/pos/BentoOrderNotificationEnhanced';
// import POSRegister from './components/pos/POSRegister'; // 2025-09-24 アーカイブ済み（POSRegisterFullScreenに統一）
import POSRegisterFullScreen from './components/pos/POSRegisterFullScreen';
import SettingsPage from './components/admin/Settings';
import PrinterSettings from './components/admin/PrinterSettings';
import PointSettings from './components/admin/PointSettings';
import TaxSettings from './components/settings/TaxSettings';
import AccordionSidebarMenu from './components/layout/AccordionSidebarMenu';
import PageContainer from './components/layout/PageContainer';
import TemporaryAdminModal from './components/common/TemporaryAdminModal';

// import InventoryManagementEnhanced from './components/inventory/InventoryManagementEnhanced'; // Phase 3で削除
import SimpleStockInput from './components/inventory/SimpleStockInput';
import SimpleStockView from './components/inventory/SimpleStockView';
import SalesAnalytics from './components/analytics/SalesAnalytics';
import SalesAnalyticsWithWeather from './components/analytics/SalesAnalyticsWithWeather';
import SalesManagement from './components/sales/SalesManagement';
import ReservationManagement from './components/reservations/ReservationManagement';
import MenuManagement from './components/menu/MenuManagement';
import LineMemberManagementDynamic from './components/line/LineMemberManagementDynamic';
import MemberStatisticsDashboard from './components/line/MemberStatisticsDashboard';
import AchievementMasterList from './components/admin/AchievementMasterList';
import UserAchievementManager from './components/admin/UserAchievementManager';
import AIPredictionEnhanced from './components/ai/AIPredictionEnhanced';
import AttendanceManagement from './components/attendance/AttendanceManagement';
import SimpleAttendance from './components/attendance/SimpleAttendance';
import QuickAttendance from './components/attendance/QuickAttendance';
import ShiftCalendar from './components/attendance/ShiftCalendar';
import ShiftCalendarEnhanced from './components/attendance/ShiftCalendarEnhanced';
import AttendanceReport from './components/attendance/AttendanceReport';
import StaffManagementEnhanced from './components/staff/StaffManagementEnhanced';
import DeveloperTools from './components/developer/DeveloperTools';
// import InventoryIntegrationDashboard from './components/inventory/InventoryIntegrationDashboard'; // Phase 3で削除
import IngredientManagement from './components/inventory/IngredientManagement';
import RecipeManagement from './components/inventory/RecipeManagement';
import BentoInventoryIntegration from './components/inventory/BentoInventoryIntegration';
import PurchaseOrderManagement from './components/inventory/PurchaseOrderManagement';
// import InventoryCount from './components/inventory/InventoryCount'; // Phase 3で削除
import DashboardV3 from './components/dashboard/DashboardV3';
import DashboardV2 from './components/dashboard/DashboardV2';
import Dashboard from './components/dashboard/Dashboard';
import SupplierManagement from './components/purchase/SupplierManagement';
import PurchaseOrdersManagement from './components/purchase/PurchaseOrderManagement';
import ProfitLossDashboard from './components/accounting/ProfitLossDashboard';
import PaymentScheduleCalendar from './components/accounting/PaymentScheduleCalendar';
import ABCAnalysisDashboard from './components/analytics/ABCAnalysisDashboard';

// LINE機能コンポーネント
import TakeoutOrder from './components/line/TakeoutOrder';
import TakeoutManagement from './components/admin/TakeoutManagement';
import BentoOrderManagement from './components/admin/BentoOrderManagement';
import BentoMenuManager from './components/admin/BentoMenuManager';
import BentoReservationManager from './components/admin/BentoReservationManager';
import BentoAnalytics from './components/admin/BentoAnalytics';
import Analytics from './components/admin/Analytics';
import PayrollManagementEnhanced from './components/payroll/PayrollManagementEnhanced';
import PointShopCustomer from './components/shop/PointShopCustomer';
import PointShopManagerCustom from './components/admin/PointShopManagerCustom';
import LoginHistory from './components/admin/LoginHistory';
import AccountingManagement from './components/accounting/AccountingManagement';
import ExpenseManagement from './components/accounting/ExpenseManagement';
import CashBookManagement from './components/accounting/CashBookManagement';
// import InventoryValuation from './components/accounting/InventoryValuation'; // Phase 3で削除
import BackupSettings from './components/admin/BackupSettings';
import AutoDistributionManager from './components/admin/AutoDistributionManager';
import FeatureFlagsManagement from './components/admin/FeatureFlagsManagement';
import PermissionManagement from './components/admin/PermissionManagement';
import CouponAnalyticsDashboard from "./components/analytics/coupon/CouponAnalyticsDashboard"; // クーポン履歴管理 (Phase 1A)
import RevenueAnalyticsDashboard from "./components/analytics/coupon/RevenueAnalyticsDashboard"; // クーポン収益分析 (Phase 1B)

// レポートコンポーネント
import DailyReportCalendar from './components/reports/DailyReportCalendar';
import ReportList from './components/reports/ReportList';
import DailyReportGenerator from './components/reports/DailyReportGenerator';

function Navigation() {
  const location = useLocation();
  const { state, logout, isAdmin, isDeveloper } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showExitDialog, setShowExitDialog] = useState(false);
  const [showClosingConfirm, setShowClosingConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTempAdminModal, setShowTempAdminModal] = useState(false);

  // 旧navItems配列（AccordionSidebarMenuに移行済み）
  const navItems = [
    { path: '/', label: 'POSレジ', icon: '💳', requireAuth: true },
    { path: '/home', label: 'ホーム画面', icon: '🏠', requireAuth: true },
    { path: '/analytics', label: 'ダッシュボード', icon: '📊', requireAuth: true, adminOnly: true },
    { path: '/menu', label: 'メニュー管理', icon: '🍽️', requireAuth: true, adminOnly: true },
    { path: '/inventory', label: '在庫管理', icon: '📦', requireAuth: true },
    { path: '/inventory-dashboard', label: '在庫×弁当連動', icon: '🔗', requireAuth: true },
    { path: '/recipe-management', label: 'レシピ管理', icon: '📖', requireAuth: true },
    { path: '/bento-inventory', label: '弁当在庫連携', icon: '📦', requireAuth: true },
    { path: '/purchase-order', label: '発注書管理', icon: '📄', requireAuth: true },
    { path: '/inventory-count', label: '棚卸し管理', icon: '📋', requireAuth: true },
    { path: '/ai-prediction', label: 'AI予測', icon: '🤖', requireAuth: true, adminOnly: true },
    { path: '/attendance', label: 'かんたん勤怠', icon: '⏰', requireAuth: true },
    { path: '/shift-calendar', label: 'シフトカレンダー', icon: '📅', requireAuth: true, adminOnly: true },
    { path: '/line', label: 'LINE会員管理', icon: '💬', requireAuth: true, adminOnly: true },
    { path: '/takeout', label: 'テイクアウト予約', icon: '🍱', requireAuth: false },
    { path: '/takeout-management', label: 'テイクアウト管理', icon: '📦', requireAuth: true },
    { path: '/bento-orders', label: '弁当予約管理', icon: '🍱', requireAuth: true },
    { path: '/bento-manager', label: '弁当予約総合', icon: '🍱', requireAuth: true },
    { path: '/bento-reservation', label: '弁当予約', icon: '📝', requireAuth: true },
    { path: '/bento-analytics', label: '弁当分析', icon: '📊', requireAuth: true },
    // { path: '/line-analytics', label: 'LINE分析', icon: '📊', requireAuth: true, adminOnly: true }, // 削除: /line/statistics と重複のためサイドバーから非表示
    { path: '/payroll', label: '給与管理', icon: '💰', requireAuth: true, adminOnly: true },
    { path: '/settings', label: '設定', icon: '⚙️', requireAuth: true },
  ];

  // 開発環境の場合、開発者ツールを追加
  if (process.env.NODE_ENV === 'development' || window.location.search.includes('dev=true')) {
    navItems.push({ path: '/developer', label: '開発者ツール', icon: '🔧', requireAuth: true, adminOnly: true });
  }

  // フィルタリング: 権限に応じて表示するメニューを制限
  const filteredNavItems = navItems.filter(item => {
    if (item.adminOnly && !isAdmin()) return false;
    return true;
  });

  // Hide navigation on login screen only
  if (location.pathname === '/login') {
    return null;
  }

  const handleLogout = async () => {
    await logout();
    setIsMenuOpen(false);
  };

  // 締め作業を実行
  const performClosingProcess = async () => {
    try {
      const apiHost = window.location.hostname;
      const response = await axios.post(`http://${apiHost}:3001/api/daily-closing`, {
        closingDate: new Date().toISOString()
      });
      
      if (response.data.success) {
        console.log('締め作業が完了しました:', response.data);
        return true;
      }
      return false;
    } catch (error) {
      console.error('締め作業でエラーが発生しました:', error);
      return false;
    }
  };

  // シャットダウン処理
  const handleShutdown = async (performClosing: boolean) => {
    setLoading(true);
    
    try {
      if (performClosing) {
        // 締め作業を実行
        const closingSuccess = await performClosingProcess();
        if (!closingSuccess) {
          alert('締め作業に失敗しました。手動で締め作業を行ってください。');
        }
        // 状態をクリア
        localStorage.removeItem('waton_pos_state');
      }
      
      // シャットダウンAPIを呼び出し
      const apiHost = window.location.hostname;
      await axios.post(`http://${apiHost}:3001/api/shutdown`, {
        performClosing,
        closeAll: true
      });
      
      // ブラウザウィンドウを閉じる
      window.close();
      // それでも閉じない場合は、空のページに遷移
      setTimeout(() => {
        window.location.href = 'about:blank';
      }, 100);
      
    } catch (error) {
      console.error('シャットダウン処理でエラー:', error);
      alert('システムの終了に失敗しました。手動で終了してください。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Menu Toggle Button (全デバイスで表示) */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="fixed top-4 left-4 z-50 bg-blue-600 text-white p-2 rounded-md shadow-lg hover:bg-blue-700 transition-colors"
        title={isMenuOpen ? 'メニューを閉じる' : 'メニューを開く'}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {isMenuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* 一時管理者権限ボタン（スタッフログイン時のみ表示） */}
      {state.user && !isAdmin() && (
        <button
          onClick={() => setShowTempAdminModal(true)}
          className={`fixed top-4 left-20 z-50 ${
            state.temporaryAdminMode
              ? 'bg-green-600 hover:bg-green-700'
              : 'bg-purple-600 hover:bg-purple-700'
          } text-white p-2 rounded-md shadow-lg transition-colors`}
          title={state.temporaryAdminMode ? '一時管理者権限（有効）' : '一時管理者権限'}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          {state.temporaryAdminMode && (
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-green-400 rounded-full animate-pulse"></span>
          )}
        </button>
      )}

      {/* アコーディオンサイドバー（モバイル＆デスクトップ共通） */}
      <AccordionSidebarMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        isAdmin={isAdmin()}
        isDeveloper={isDeveloper()}
        onLogout={handleLogout}
      />

      {/* 終了確認ダイアログ */}
      {showExitDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md">
            <h3 className="text-2xl font-bold mb-6">システムを終了しますか？</h3>
            
            <div className="mb-6">
              <p className="text-gray-600 mb-4">
                本日の営業は終了ですか？締め作業を行いますか？
              </p>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => {
                  setShowExitDialog(false);
                  setShowClosingConfirm(true);
                }}
                className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
              >
                締め作業を行って終了
              </button>
              
              <button
                onClick={() => {
                  setShowExitDialog(false);
                  handleShutdown(false);
                }}
                className="w-full py-3 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-700"
              >
                締め作業をせずに終了（再開可能）
              </button>
              
              <button
                onClick={() => setShowExitDialog(false)}
                className="w-full py-3 bg-gray-300 rounded-lg font-medium hover:bg-gray-400"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 締め作業確認ダイアログ */}
      {showClosingConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md">
            <h3 className="text-2xl font-bold mb-6 text-red-600">締め作業の最終確認</h3>
            
            <div className="mb-6">
              <div className="p-4 bg-red-50 border border-red-300 rounded-lg">
                <p className="font-bold text-red-800 mb-2">
                  ⚠️ 締め作業を実行すると：
                </p>
                <ul className="text-sm text-red-700 space-y-1 list-disc list-inside">
                  <li>本日の売上が確定されます</li>
                  <li>日次レポートが生成されます</li>
                  <li>システムが完全にリセットされます</li>
                  <li>この操作は取り消せません</li>
                </ul>
              </div>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => {
                  setShowClosingConfirm(false);
                  handleShutdown(true);
                }}
                className="w-full py-3 bg-red-600 text-white rounded-lg font-bold hover:bg-red-700"
                disabled={loading}
              >
                {loading ? '処理中...' : '締め作業を実行して終了'}
              </button>
              
              <button
                onClick={() => setShowClosingConfirm(false)}
                className="w-full py-3 bg-gray-300 rounded-lg font-medium hover:bg-gray-400"
                disabled={loading}
              >
                戻る
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black opacity-50 z-30"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* 一時管理者権限モーダル */}
      <TemporaryAdminModal
        isOpen={showTempAdminModal}
        onClose={() => setShowTempAdminModal(false)}
      />
    </>
  );
}

function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  // デバッグログ
  useEffect(() => {
    console.log('[Layout] マウント完了 path:', location.pathname);
  }, [location.pathname]);

  // POSレジ画面では上部ヘッダーにボタンがあるので、固定ボタンを非表示
  const isPOSScreen = location.pathname === '/' || location.pathname === '/pos-fullscreen';

  console.log('[Layout] レンダリング - isPOSScreen:', isPOSScreen, 'unreadCount:', unreadCount);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* グローバル弁当予約通知（全画面で動作） - 通知設定ボタンは非表示 */}
      <BentoOrderNotificationEnhanced
        hideSettingsButton={true}
        onUnreadCountChange={(count) => setUnreadCount(count)}
      />

      {/* 未読数をwindowオブジェクトに保存（POSRegisterFullScreenから参照） */}
      {(() => {
        (window as any).bentoUnreadCount = unreadCount;
        return null;
      })()}

      {/* 弁当予約管理ボタン（右下固定） - POSレジ以外の画面で表示 */}
      {!isPOSScreen && location.pathname !== '/bento-reservation' && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999
        }}>
          <button
            onClick={() => navigate('/bento-reservation')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: unreadCount > 0 ? '#dc2626' : '#2563eb',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '50px',
              border: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
              cursor: 'pointer',
              position: 'relative',
              transition: 'all 0.3s ease',
              animation: unreadCount > 0 ? 'pulse 2s infinite' : 'none'
            }}
          >
            <span style={{ fontSize: '20px' }}>🍱</span>
            <span>弁当予約管理</span>
            {unreadCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-8px',
                right: '-8px',
                backgroundColor: '#fbbf24',
                color: '#000',
                borderRadius: '50%',
                width: '28px',
                height: '28px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 'bold',
                border: '2px solid white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                {unreadCount}
              </span>
            )}
          </button>
        </div>
      )}

      <Navigation />
      <main className="pt-0">
        {children}
      </main>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}

// 認証が必要なルートを保護するコンポーネント
function ProtectedRoute({ children, adminOnly = false, developerOnly = false }: { children: React.ReactNode; adminOnly?: boolean; developerOnly?: boolean }) {
  const { state, isAdmin, isDeveloper } = useAuth();

  // ローディング中
  if (state.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // 未認証の場合はログインページへ
  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 開発者専用ページ: developerOnly の場合は isDeveloper または dev mode を要求
  if (developerOnly) {
    const isDevMode = window.location.search.includes('dev=true');
    if (!isDeveloper() && !isDevMode) {
      return (
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <p className="text-red-600 text-xl">アクセス権限がありません</p>
            <p className="mt-2">開発者権限が必要です</p>
          </div>
        </div>
      );
    }
  }

  // 管理者権限が必要で、管理者でない場合
  if (adminOnly && !isAdmin()) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-red-600 text-xl">アクセス権限がありません</p>
          <p className="mt-2">管理者権限が必要です</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

function AppContent() {
  const { state, verifyToken } = useAuth();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    // 初回マウント時にトークンを検証
    const checkAuth = async () => {
      if (state.token) {
        await verifyToken();
      }
      setIsVerifying(false);
    };
    checkAuth();
  }, []);

  if (isVerifying) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      {/* ログイン画面（認証不要） */}
      <Route path="/login" element={
        state.isAuthenticated ? <Navigate to="/" replace /> : <PinLoginFormEnhanced />
      } />
      
      {/* デフォルトルート - フルスクリーン版POS */}
      <Route path="/" element={
        <ProtectedRoute>
          <Layout>
            <POSRegisterFullScreen />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* POS通常版 - 2025-09-24 アーカイブ済み（POSRegisterFullScreenに統一） */}
      {/* /pos へのアクセスは /pos-fullscreen にリダイレクト */}
      <Route path="/pos" element={<Navigate to="/pos-fullscreen" replace />} />

      {/* POSレジフルスクリーン */}
      <Route path="/pos-fullscreen" element={
        <ProtectedRoute>
          <Layout>
            <POSRegisterFullScreen />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* 新しいホーム画面 */}
      <Route path="/home" element={
        <ProtectedRoute>
          <>
            <Navigation />
            <DashboardV3 />
          </>
        </ProtectedRoute>
      } />

      {/* ポイントショップ顧客画面 */}
      <Route path="/point-shop" element={
        <ProtectedRoute>
          <>
            <Navigation />
            <PointShopCustomer isDemo={false} />
          </>
        </ProtectedRoute>
      } />

      {/* ポイントショップ管理画面（カスタマイズ対応版） */}
      <Route path="/point-shop-admin" element={
        <ProtectedRoute>
          <>
            <Navigation />
            <PointShopManagerCustom />
          </>
        </ProtectedRoute>
      } />
      
      <Route element={<Layout><Outlet /></Layout>}>
        {/* 旧ダッシュボード */}
        <Route path="/dashboard" element={
          <ProtectedRoute adminOnly>
            <Dashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/menu" element={
          <ProtectedRoute adminOnly>
            <MenuManagement />
          </ProtectedRoute>
        } />
        
        {/* 新しいシンプル在庫管理 */}
        <Route path="/stock-input" element={
          <ProtectedRoute>
            <SimpleStockInput />
          </ProtectedRoute>
        } />

        <Route path="/stock-view" element={
          <ProtectedRoute>
            <SimpleStockView />
          </ProtectedRoute>
        } />

        {/* 既存の在庫管理（削除済み - Phase 3） */}
        {/* <Route path="/inventory" element={
          <ProtectedRoute>
            <InventoryManagementEnhanced />
          </ProtectedRoute>
        } /> */}

        {/* <Route path="/inventory-dashboard" element={
          <ProtectedRoute>
            <InventoryIntegrationDashboard />
          </ProtectedRoute>
        } /> */}

        <Route path="/recipe-management" element={
          <ProtectedRoute>
            <RecipeManagement />
          </ProtectedRoute>
        } />

        <Route path="/bento-inventory" element={
          <ProtectedRoute>
            <BentoInventoryIntegration />
          </ProtectedRoute>
        } />

        <Route path="/purchase-order" element={
          <ProtectedRoute>
            <PurchaseOrderManagement />
          </ProtectedRoute>
        } />

        {/* <Route path="/inventory-count" element={
          <ProtectedRoute>
            <InventoryCount />
          </ProtectedRoute>
        } /> */}

        <Route path="/suppliers" element={
          <ProtectedRoute adminOnly>
            <SupplierManagement />
          </ProtectedRoute>
        } />

        <Route path="/purchase-orders" element={
          <ProtectedRoute adminOnly>
            <PurchaseOrdersManagement />
          </ProtectedRoute>
        } />

        <Route path="/expenses" element={
          <ProtectedRoute adminOnly>
            <ExpenseManagement />
          </ProtectedRoute>
        } />

        <Route path="/profit-loss" element={
          <ProtectedRoute adminOnly>
            <ProfitLossDashboard />
          </ProtectedRoute>
        } />

        <Route path="/payment-schedule" element={
          <ProtectedRoute adminOnly>
            <PaymentScheduleCalendar />
          </ProtectedRoute>
        } />

        <Route path="/abc-analysis" element={
          <ProtectedRoute adminOnly>
            <ABCAnalysisDashboard />
          </ProtectedRoute>
        } />

        <Route path="/analytics" element={
          <ProtectedRoute adminOnly>
            <SalesAnalyticsWithWeather />
          </ProtectedRoute>
        } />
        <Route path="/sales-management" element={
          <ProtectedRoute adminOnly>
            <SalesManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/ai-prediction" element={
          <ProtectedRoute adminOnly>
            <AIPredictionEnhanced />
          </ProtectedRoute>
        } />
        
        <Route path="/reservations" element={
          <ProtectedRoute>
            <ReservationManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/attendance" element={
          <QuickAttendance />
        } />
        
        <Route path="/attendance-old" element={
          <ProtectedRoute>
            <AttendanceManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/shift-calendar" element={
          <ProtectedRoute adminOnly>
            <ShiftCalendarEnhanced />
          </ProtectedRoute>
        } />
        
        <Route path="/attendance-report" element={
          <ProtectedRoute>
            <AttendanceReport />
          </ProtectedRoute>
        } />

        {/* 日報カレンダー */}
        <Route path="/reports/calendar" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <DailyReportCalendar />
            </Layout>
          </ProtectedRoute>
        } />

        {/* 週報・月報一覧 */}
        <Route path="/reports/list" element={
          <ProtectedRoute adminOnly>
            <ReportList />
          </ProtectedRoute>
        } />

        {/* 日報詳細 */}
        <Route path="/reports/daily" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <DailyReportGenerator />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/staff" element={
          <ProtectedRoute adminOnly>
            <StaffManagementEnhanced />
          </ProtectedRoute>
        } />
        
        <Route path="/line" element={
          <ProtectedRoute adminOnly>
            <LineMemberManagementDynamic />
          </ProtectedRoute>
        } />

        <Route path="/line/statistics" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <MemberStatisticsDashboard />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/achievements/master" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <AchievementMasterList />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/achievements/users" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <UserAchievementManager />
            </Layout>
          </ProtectedRoute>
        } />
        
        {/* ポイントカードは削除（LINE会員管理に統合） */}
        
        <Route path="/takeout" element={
          <TakeoutOrder />
        } />
        
        <Route path="/takeout-management" element={
          <ProtectedRoute>
            <TakeoutManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/bento-orders" element={
          <ProtectedRoute>
            <BentoOrderManagement />
          </ProtectedRoute>
        } />

        <Route path="/bento-menu" element={
          <ProtectedRoute adminOnly>
            <Layout>
              <BentoMenuManager />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/bento-reservation" element={
          <ProtectedRoute>
            <BentoReservationManager />
          </ProtectedRoute>
        } />
        
        <Route path="/bento-manager" element={
          <ProtectedRoute>
            <BentoReservationManager />
          </ProtectedRoute>
        } />
        
        <Route path="/bento-analytics" element={
          <ProtectedRoute>
            <BentoAnalytics />
          </ProtectedRoute>
        } />
        
        <Route path="/line-analytics" element={
          <ProtectedRoute adminOnly>
            <Analytics />
          </ProtectedRoute>
        } />
        <Route path="/coupon-analytics" element={
          <ProtectedRoute adminOnly>
            <CouponAnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/revenue-analytics" element={
          <ProtectedRoute adminOnly>
            <RevenueAnalyticsDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/payroll" element={
          <ProtectedRoute adminOnly>
            <PayrollManagementEnhanced />
          </ProtectedRoute>
        } />

        <Route path="/accounting" element={
          <ProtectedRoute adminOnly>
            <AccountingManagement />
          </ProtectedRoute>
        } />

        <Route path="/expenses" element={
          <ProtectedRoute adminOnly>
            <ExpenseManagement />
          </ProtectedRoute>
        } />

        <Route path="/cash-book" element={
          <ProtectedRoute adminOnly>
            <CashBookManagement />
          </ProtectedRoute>
        } />
        {/* <Route path="/inventory-valuation" element={<ProtectedRoute requiredLevel={1}><InventoryValuation /></ProtectedRoute>} /> */}

        <Route path="/settings" element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } />
        
        <Route path="/settings/printer" element={
          <ProtectedRoute>
            <PrinterSettings />
          </ProtectedRoute>
        } />
        
        <Route path="/settings/staff" element={
          <ProtectedRoute adminOnly>
            <StaffManagementEnhanced />
          </ProtectedRoute>
        } />

        <Route path="/login-history" element={
          <ProtectedRoute adminOnly>
            <LoginHistory />
          </ProtectedRoute>
        } />
        
        <Route path="/settings/points" element={
          <ProtectedRoute adminOnly>
            <PointSettings />
          </ProtectedRoute>
        } />

        <Route path="/settings/tax" element={
          <ProtectedRoute adminOnly>
            <TaxSettings />
          </ProtectedRoute>
        } />

        <Route path="/settings/backup" element={
          <ProtectedRoute adminOnly>
            <BackupSettings />
          </ProtectedRoute>
        } />

        <Route path="/settings/bento-menu" element={
          <ProtectedRoute adminOnly>
            <BentoMenuManager />
          </ProtectedRoute>
        } />

        <Route path="/settings/login-history" element={
          <ProtectedRoute adminOnly>
            <LoginHistory />
          </ProtectedRoute>
        } />

        <Route path="/backup" element={
          <ProtectedRoute adminOnly>
            <BackupSettings />
          </ProtectedRoute>
        } />

        <Route path="/developer" element={
          <ProtectedRoute adminOnly>
            <DeveloperTools />
          </ProtectedRoute>
        } />

        <Route path="/ingredients" element={
          <ProtectedRoute>
            <IngredientManagement />
          </ProtectedRoute>
        } />

        <Route path="/admin/auto-distribution" element={
          <ProtectedRoute adminOnly>
            <AutoDistributionManager />
          </ProtectedRoute>
        } />

        <Route path="/admin/feature-flags" element={
          <ProtectedRoute adminOnly>
            <FeatureFlagsManagement />
          </ProtectedRoute>
        } />

        <Route path="/admin/permissions" element={
          <ProtectedRoute developerOnly>
            <PermissionManagement />
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;